import { Button, HStack } from '@chakra-ui/react'
import { memo } from 'react'

import { useDevicesI18n } from '../i18n'
import type { DevicesListFilters as DevicesListFiltersType } from '../types/device.types'
import { DevicesListFilters } from './DevicesListFilters'
import { SideSheetDialog } from './SideSheetDialog'

interface DevicesListFiltersSideSheetProps {
  isOpen: boolean
  value: Partial<DevicesListFiltersType>
  onChange: (filters: Partial<DevicesListFiltersType>) => void
  onClear: () => void
  onCancel: () => void
  onApply: () => void
}

export const DevicesListFiltersSideSheet =
  memo<DevicesListFiltersSideSheetProps>(
    ({ isOpen, value, onChange, onClear, onCancel, onApply }) => {
      const { text } = useDevicesI18n()

      return (
        <SideSheetDialog
          isOpen={isOpen}
          onClose={onCancel}
          title={text('devices.filters.title', 'Filter')}
          width="420px"
          body={<DevicesListFilters value={value} onChange={onChange} />}
          footer={
            <HStack gap={3} w="full" justify="space-between">
              <Button variant="ghost" colorPalette="neutral" onClick={onClear}>
                {text('devices.filters.clearFilters', 'Clear filters')}
              </Button>
              <HStack gap={3}>
                <Button
                  variant="outline"
                  colorPalette="neutral"
                  onClick={onCancel}
                >
                  {text('devices.common.cancel', 'Cancel')}
                </Button>
                <Button colorPalette="brand" onClick={onApply}>
                  {text('devices.filters.apply', 'Apply')}
                </Button>
              </HStack>
            </HStack>
          }
        />
      )
    },
  )

DevicesListFiltersSideSheet.displayName = 'DevicesListFiltersSideSheet'
